import { render, staticRenderFns } from "./SystemObjects.vue?vue&type=template&id=03032f8f"
import script from "./SystemObjects.vue?vue&type=script&lang=js"
export * from "./SystemObjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports